<template>
  <div class="page-search d-lg-flex mx-0 px-0">
    <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="400" offset-y transition="scale-transition">
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on" class="search-btn" @click="openSearch">
          <v-icon>mdi-magnify-expand</v-icon>
        </v-btn>
      </template>

      <v-card class="search-card">
        <v-card-title class="search-title">
          <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('search.placeholder')" single-line
            hide-details autofocus autocomplete="off" @input="filterPages" @keydown.esc="closeSearch"
            @keydown.enter="navigateToFirstResult" ref="searchInput"></v-text-field>
        </v-card-title>

        <v-card-text>
          <v-list v-if="filteredPages && filteredPages.length > 0" class="search-list">
            <v-list-item v-for="(page, index) in filteredPages" :key="page.path + index" @click="navigateTo(page.path)"
              class="search-item" :class="{ 'search-item-active': index === activeIndex }">
              <v-list-item-icon>
                <v-icon>{{ page.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ page.title }}</v-list-item-title>
                <v-list-item-subtitle v-if="page.description && page.description != ''">{{ page.description
                  }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-icon small>mdi-chevron-right</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <div v-else class="text-center pa-4">
            {{ $t('search.no_results') }}
          </div>
        </v-card-text>

        <v-card-actions class="search-actions">
          <v-spacer></v-spacer>
          <v-btn text small @click="closeSearch">
            {{ $t('search.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'PageSearch',
  data() {
    return {
      menu: false,
      search: '',
      activeIndex: 0,
      filteredPages: [],
      focusTimeout: null,
      pages: [],
      visitHistory: {} // Для хранения истории посещений
    }
  },
  computed: {
    isMobile() {
      if (this.$vuetify && this.$vuetify.breakpoint) {
        return this.$vuetify.breakpoint.name === "xs" || this.$vuetify.breakpoint.name === "sm";
      }
      return false;
    },
    isNative() {
      return false; // Замените на действительное значение, если требуется
    },
    company() {
      if (this.$store.getters.getCompany && this.$store.getters.getCompany.company) {
        return this.$store.getters.getCompany.company;
      } else {
        return null;
      }
    },
    isCrmEnabled() {
      return this.$store.getters["crm/isCrmEnabled"];
    },
    hasCrmAccess() {
      return this.$store.getters["crm/hasCrmAccess"];
    }
  },
  created() {
    // Загружаем историю посещений из localStorage
    this.loadVisitHistory();
    this.initializeSearchPages();
  },
  methods: {
    // Загрузка истории посещений из localStorage
    loadVisitHistory() {
      try {
        const storedHistory = localStorage.getItem('pageVisitHistory');
        if (storedHistory) {
          this.visitHistory = JSON.parse(storedHistory);
        }
      } catch (error) {
        console.error('Ошибка загрузки истории посещений:', error);
        this.visitHistory = {};
      }
    },

    // Сохранение истории посещений в localStorage
    saveVisitHistory() {
      try {
        localStorage.setItem('pageVisitHistory', JSON.stringify(this.visitHistory));
      } catch (error) {
        console.error('Ошибка сохранения истории посещений:', error);
      }
    },

    // Запись посещения страницы
    recordVisit(path) {
      if (!path) return;

      // Если путь уже есть в истории, увеличиваем счетчик
      if (this.visitHistory[path]) {
        this.visitHistory[path] += 1;
      } else {
        // Иначе создаем запись с начальным значением 1
        this.visitHistory[path] = 1;
      }

      // Сохраняем обновленную историю
      this.saveVisitHistory();
    },

    // Получение популярности страницы
    getPopularity(path) {
      return this.visitHistory[path] || 0;
    },
    menu_object_name() {
      if (this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.rental_object) {
        const rentalObject = this.$store.getters.getCompany.company.rental_object;

        const typeMap = {
          'cars': 'rental_objects.cars_menu',
          'bicycles': 'rental_objects.bicycles_menu',
          'motorcycles': 'rental_objects.motorcycles_menu',
          'boats': 'rental_objects.boats_menu',
          'construction_machinery': 'rental_objects.construction_machinery_menu',
          'equipment': 'rental_objects.equipment_menu',
          'airplanes': 'rental_objects.airplanes_menu',
          'trucks': 'rental_objects.trucks_menu',
          'trailers': 'rental_objects.trailers_menu',
          'caravans': 'rental_objects.caravans_menu',
          'taxies': 'rental_objects.taxies_menu',
          'other': 'rental_objects.other_menu'
        };

        if (typeMap[rentalObject]) {
          return this.$t(typeMap[rentalObject]);
        }
      }

      return this.$t('rental_objects.cars_menu') || 'Автомобили';
    },
    initializeSearchPages() {
      // Базовые страницы, доступные всем
      let basePages = [
        {
          title: this.$t('custom.main'),
          path: '/dashboard',
          icon: 'mdi-home',
          description: this.$t('custom.main')
        },
        {
          title: this.$t('custom.bookings'),
          path: '/bookings/list',
          icon: 'mdi-book-multiple',
          description: this.$t('custom.bookings')
        },
        {
          title: this.$t('custom.day_plan'),
          path: '/calendars/timeline',
          icon: 'mdi-calendar-cursor',
          description: this.$t('custom.day_plan')
        },
        {
          title: this.$t('custom.calendar'),
          path: '/calendars/gantt',
          icon: 'mdi-chart-gantt',
          description: this.$t('custom.calendar')
        },
        {
          title: this.$t('custom.add_booking'),
          path: '/booking/new',
          icon: 'mdi-plus-box',
          description: this.$t('custom.add_booking')
        },
        {
          title: this.$t('custom.search_free'),
          path: '/search_free',
          icon: 'mdi-car-search-outline',
          description: this.$t('custom.search_free')
        }
      ];

      // Для агентов исключаем некоторые базовые страницы
      if (this.user_role === 'agent') {
        basePages = basePages.filter(page =>
          page.path !== '/bookings/list' &&
          page.path !== '/calendars/timeline' &&
          page.path !== '/calendars/gantt'
        );
      }

      // Генерируем остальные страницы в зависимости от роли пользователя
      let roleSpecificItems = [];

      if (this.isAdminPlus || this.isGuest) {
        roleSpecificItems = this.getItemsForRole('items');
      } else if (this.user_role === 'manager') {
        roleSpecificItems = this.getItemsForRole('manager_items');
      } else if (this.user_role === 'partner') {
        roleSpecificItems = this.getItemsForRole('partners_items');
      } else if (this.user_role === 'agent') {
        roleSpecificItems = this.getItemsForRole('agents_items');
      } else {
        roleSpecificItems = this.getItemsForRole('worker_items');
      }

      // Добавляем дополнительные страницы
      const additionalPages = this.getAdditionalPages();

      // Объединяем все страницы
      this.pages = [...basePages, ...roleSpecificItems, ...additionalPages];

      // Фильтруем уникальные пути
      this.pages = this.uniqueByPath(this.pages);

      // Применяем сортировку по популярности сразу при инициализации
      this.filterPages();
    },

    // Генерирует страницы на основе групп меню (аналогично Drawer.vue)
    getItemsForRole(roleItems) {
      const items = [];

      // Определяем все группы элементов для разных ролей, полностью копируя из Drawer.vue
      const roleItemsMap = {
        'items': [
          {
            icon: "mdi-car-multiple",
            title: this.menu_object_name(),
            items: [
              {
                title: this.menu_object_name(),
                icon: "mdi-car-multiple",
                to: "/vehicles/list",
              },
              {
                title: this.$t("custom.add_car"),
                icon: "mdi-plus-box",
                to: "/cars/new",
              },
            ],
          },
          {
            icon: "mdi-calendar-account-outline",
            title: this.$t("custom.clients"),
            items: [
              {
                title: this.$t("custom.clients"),
                icon: "mdi-calendar-account-outline",
                to: "/clients",
              },
              {
                title: this.$t("custom.fines"),
                icon: "mdi-car-emergency",
                to: "/fines",
              },
              {
                title: this.$t("custom.debts"),
                icon: "mdi-credit-card-remove-outline",
                to: "/debts",
              },
              {
                title: this.$t("custom.invoices"),
                icon: "mdi-receipt",
                to: "/invoices",
              },
              {
                title: this.$t("custom.add_client"),
                icon: "mdi-plus-box",
                to: "/client/new",
              },
            ],
          },
          {
            icon: "mdi-cash-register",
            title: this.$t("custom.counts"),
            items: [
              {
                title: this.$t("custom.counts"),
                icon: "mdi-cash-register",
                to: "/counts",
              },
              {
                title: this.$t("header.company_counts"),
                icon: "mdi-cash-lock",
                to: "/company_counts",
              },
              {
                title: this.$t("header.add_payment"),
                icon: "mdi-book-plus-multiple",
                to: "/counts/new",
              },
            ],
          },
          {
            icon: "mdi-book-plus-multiple",
            title: this.$t("custom.service"),
            items: [
              {
                title: this.$t("custom.tech_service"),
                icon: "mdi-car-cog",
                to: "/service_tech",
              },
              {
                title: this.$t("maintenance.insurances_and_taxes"),
                icon: "mdi-shield-car",
                to: "/service_insurance",
              },
              {
                title: this.$t("maintenance.payments"),
                icon: "mdi-cash-sync",
                to: "/service_payments",
              },
            ],
          },
          {
            icon: "mdi-domain",
            title: this.$t("header.company"),
            items: [
              {
                title: this.$t("custom.analitics"),
                icon: "mdi-chart-areaspline",
                to: "/analitics",
              },
              {
                title: this.$t("custom.employers"),
                icon: "mdi-account-hard-hat",
                to: "/admin/users",
              },
              {
                title: this.$t("custom.schedule"),
                icon: "mdi-calendar-multiselect",
                to: "/schedule_calendar",
              },
              {
                title: this.$t("custom.salary"),
                icon: "mdi-account-cash-outline",
                to: "/salary",
              },
              {
                title: this.$t("header.partners"),
                icon: "mdi-handshake-outline",
                to: "/investors",
              },
              {
                title: this.$t("header.branches"),
                icon: "mdi-source-branch",
                to: "/branches",
              },
              {
                title: this.$t("custom.contractors"),
                icon: "mdi-account-convert",
                to: "/contractors",
              },
              {
                title: this.$t("home.events"),
                icon: "mdi-history",
                to: "/history",
              },
              {
                title: this.$t("header.company_settings"),
                icon: "mdi-cog-box",
                to: "/company_profile",
              },
              {
                title: this.$t("agents.agents"),
                icon: "mdi-face-agent",
                to: "/agents",
              },
              {
                title: this.$t("header.check_lists"),
                icon: "mdi-clipboard-check-outline",
                to: "/check_lists",
              },
              {
                title: this.$t("header.tariffs"),
                icon: "mdi-cash-multiple",
                to: "/tariffs",
              },
              {
                title: this.$t("header.templates"),
                icon: "mdi-file-document-outline",
                to: "/doc_template",
              },
              {
                title: this.$t("header.mayaks"),
                icon: "mdi-map-marker-radius",
                to: "/map",
              },
              {
                title: this.$t("agregator.agregator"),
                icon: "mdi-cart-outline",
                to: "/agregator/settings",
              },
              {
                title: this.$t("locations.locations"),
                icon: "mdi-map-marker-multiple",
                to: "/locations",
              },
            ],
          },
        ],
        'manager_items': [
          {
            icon: "mdi-car-multiple",
            title: this.menu_object_name(),
            items: [
              {
                title: this.menu_object_name(),
                icon: "mdi-car-multiple",
                to: "/vehicles/list",
              },
              {
                title: this.$t("custom.add_car"),
                icon: "mdi-plus-box",
                to: "/cars/new",
              },
            ],
          },
          {
            icon: "mdi-calendar-account-outline",
            title: this.$t("custom.clients"),
            items: [
              {
                title: this.$t("custom.clients"),
                icon: "mdi-calendar-account-outline",
                to: "/clients",
              },
              {
                title: this.$t("custom.fines"),
                icon: "mdi-car-emergency",
                to: "/fines",
              },
              {
                title: this.$t("custom.debts"),
                icon: "mdi-credit-card-remove-outline",
                to: "/debts",
              },
              {
                title: this.$t("custom.invoices"),
                icon: "mdi-receipt",
                to: "/invoices",
              },
              {
                title: this.$t("custom.add_client"),
                icon: "mdi-plus-box",
                to: "/client/new",
              },
            ],
          },
          {
            icon: "mdi-cash-register",
            title: this.$t("custom.counts"),
            items: [
              {
                title: this.$t("custom.counts"),
                icon: "mdi-cash-register",
                to: "/counts",
              },
              {
                title: this.$t("header.add_payment"),
                icon: "mdi-book-plus-multiple",
                to: "/counts/new",
              },
              {
                title: this.$t("custom.contractors"),
                icon: "mdi-account-convert",
                to: "/contractors",
              },
              {
                title: this.$t("home.events"),
                icon: "mdi-math-log",
                to: "/history",
              },
            ],
          },
          {
            icon: "mdi-book-plus-multiple",
            title: this.$t("custom.service"),
            items: [
              {
                title: this.$t("custom.tech_service"),
                icon: "mdi-car-cog",
                to: "/service_tech",
              },
              {
                title: this.$t("maintenance.insurances_and_taxes"),
                icon: "mdi-shield-car",
                to: "/service_insurance",
              },
              {
                title: this.$t("maintenance.payments"),
                icon: "mdi-cash-sync",
                to: "/service_payments",
              },
            ],
          },
        ],
        'partners_items': [
          {
            icon: "mdi-car-multiple",
            title: this.menu_object_name(),
            items: [
              {
                title: this.menu_object_name(),
                icon: "mdi-car-multiple",
                to: "/vehicles/list",
              },
            ],
          },
          {
            icon: "mdi-book-plus-multiple",
            title: this.$t("custom.service"),
            items: [
              {
                title: this.$t("custom.tech_service"),
                icon: "mdi-car-cog",
                to: "/service_tech",
              },
              {
                title: this.$t("maintenance.insurances_and_taxes"),
                icon: "mdi-shield-car",
                to: "/service_insurance",
              },
              {
                title: this.$t("maintenance.payments"),
                icon: "mdi-cash-sync",
                to: "/service_payments",
              },
            ],
          },
          {
            title: this.$t("custom.analitics"),
            icon: "mdi-poll",
            to: "/investor_analytics",
          },
        ],
        'agents_items': [
          {
            icon: "mdi-cash-register",
            title: this.$t("custom.counts"),
            items: [
              {
                title: this.$t("custom.counts"),
                icon: "mdi-cash-register",
                to: "/counts",
              },
              {
                title: this.$t("header.add_payment"),
                icon: "mdi-book-plus-multiple",
                to: "/counts/new",
              },
            ],
          },
          {
            title: this.$t("custom.clients"),
            icon: "mdi-calendar-account-outline",
            items: [
              {
                title: this.$t("custom.add_client"),
                icon: "mdi-plus-box",
                to: "/client/new",
              },
            ],
          },
        ],
        'worker_items': [
          {
            icon: "mdi-car-multiple",
            title: this.menu_object_name(),
            items: [
              {
                title: this.menu_object_name(),
                icon: "mdi-car-multiple",
                to: "/vehicles/list",
              },
              {
                title: this.$t("custom.add_car"),
                icon: "mdi-plus-box",
                to: "/cars/new",
              },
            ],
          },
          {
            icon: "mdi-calendar-account-outline",
            title: this.$t("custom.clients"),
            items: [
              {
                title: this.$t("custom.clients"),
                icon: "mdi-calendar-account-outline",
                to: "/clients",
              },
              {
                title: this.$t("custom.fines"),
                icon: "mdi-car-emergency",
                to: "/fines",
              },
              {
                title: this.$t("custom.debts"),
                icon: "mdi-credit-card-remove-outline",
                to: "/debts",
              },
              {
                title: this.$t("custom.invoices"),
                icon: "mdi-receipt",
                to: "/invoices",
              },
              {
                title: this.$t("custom.add_client"),
                icon: "mdi-plus-box",
                to: "/client/new",
              },
            ],
          },
          {
            icon: "mdi-cash-register",
            title: this.$t("custom.counts"),
            items: [
              {
                title: this.$t("custom.counts"),
                icon: "mdi-cash-register",
                to: "/counts",
              },
              {
                title: this.$t("header.add_payment"),
                icon: "mdi-book-plus-multiple",
                to: "/counts/new",
              },
              {
                title: this.$t("custom.contractors"),
                icon: "mdi-account-convert",
                to: "/contractors",
              },
            ],
          },
          {
            icon: "mdi-book-plus-multiple",
            title: this.$t("custom.service"),
            items: [
              {
                title: this.$t("custom.tech_service"),
                icon: "mdi-car-cog",
                to: "/service_tech",
              },
              {
                title: this.$t("maintenance.insurances_and_taxes"),
                icon: "mdi-shield-car",
                to: "/service_insurance",
              },
              {
                title: this.$t("maintenance.payments"),
                icon: "mdi-cash-sync",
                to: "/service_payments",
              },
            ],
          },
        ]
      };

      // Получаем группы для текущей роли
      const groups = roleItemsMap[roleItems] || [];

      // Разворачиваем вложенные элементы
      groups.forEach(group => {
        if (group.items && Array.isArray(group.items)) {
          group.items.forEach(item => {
            items.push({
              title: item.title,
              path: item.to,
              icon: item.icon,
              description: `${group.title} - ${item.title}`
            });
          });
        } else if (group.to) {
          // Если это отдельный элемент, не группа
          items.push({
            title: group.title,
            path: group.to,
            icon: group.icon,
            description: group.title
          });
        }
      });

      return items;
    },

    // Добавляет дополнительные страницы, не включенные в группы
    getAdditionalPages() {
      const additionalPages = [];

      // CRM — только если модуль включён и есть доступ (как пункт меню в шапке)
      if (this.isCrmEnabled && this.hasCrmAccess) {
        additionalPages.push({
          title: this.$t("crm.menu.leads"),
          path: "/crm/leads",
          icon: "mdi-account-multiple-plus",
          description: this.$t("crm.menu.leads")
        });
      }

      // Страницы для непартнерских и неагентских ролей
      if (this.isInternal) {
        // Общие страницы
        // Склад
        additionalPages.push({
          title: this.$t("store.store"),
          path: "/store",
          icon: "mdi-store-cog",
          description: this.$t("store.store")
        });
        // Задачи (staff, без guest — у guest нет доступа к /tasks)
        if (this.isStaff) {
          additionalPages.push({
            title: this.$t("tasks.menu"),
            path: "/tasks",
            icon: "mdi-checkbox-marked-circle-outline",
            description: this.$t("tasks.menu")
          });
        }

        // Расписание
        additionalPages.push({
          title: this.$t("custom.schedule"),
          path: "/schedule_calendar",
          icon: "mdi-calendar-multiselect",
          description: this.$t("custom.schedule")
        });

        // Зарплата
        additionalPages.push({
          title: this.$t("custom.salary"),
          path: "/salary",
          icon: "mdi-account-cash-outline",
          description: this.$t("custom.salary")
        });

        // Баланс
        additionalPages.push({
          title: this.$t("header.balance"),
          path: "/transactions",
          icon: "mdi-currency-usd",
          description: this.$t("header.balance")
        });
      }

      // Профиль пользователя
      additionalPages.push({
        title: this.$t("header.profile"),
        path: "/profile",
        icon: "mdi-account-outline",
        description: this.$t("header.profile")
      });

      // // Справка
      // additionalPages.push({
      //   title: this.$t("custom.help"),
      //   path: `/helpcenter`,
      //   icon: "mdi-help-circle",
      //   description: this.$t("custom.help")
      // });

      // WhatsApp интеграция
      if (this.company && this.company.whatsapp && this.isStaff) {
        additionalPages.push({
          title: this.$t("custom.whatsapp"),
          path: "/whatsapp_chat",
          icon: "mdi-whatsapp",
          description: this.$t("custom.whatsapp")
        });
      }

      // Teletype интеграция
      if (this.company && this.company.teletype_api_key && this.isStaff) {
        additionalPages.push({
          title: this.$t("teletype.teletype"),
          path: "/teletype",
          icon: "mdi-chat",
          description: this.$t("teletype.teletype")
        });
      }

      return additionalPages;
    },

    // Оставляет только уникальные страницы по пути
    uniqueByPath(pages) {
      const seen = new Set();
      return pages.filter(page => {
        if (!page.path || seen.has(page.path)) return false;
        seen.add(page.path);
        return true;
      });
    },

    openSearch() {
      this.menu = true;
      this.search = '';
      this.filterPages();
      this.focusTimeout = setTimeout(() => {
        if (this.$refs.searchInput) {
          this.$refs.searchInput.focus();
        }
      }, 300);
    },
    closeSearch() {
      this.menu = false;
      this.search = '';
      this.activeIndex = 0;
      if (this.focusTimeout) {
        clearTimeout(this.focusTimeout);
      }
    },
    filterPages() {
      if (!this.search) {
        // Фильтруем страницы и сортируем по популярности
        this.filteredPages = this.pages
          .filter(page => page && page.path)
          .sort((a, b) => {
            // Сортировка по популярности (по убыванию)
            return this.getPopularity(b.path) - this.getPopularity(a.path);
          });
        return;
      }

      const searchLower = this.search.toLowerCase();
      this.filteredPages = this.pages
        .filter(page => {
          if (!page || !page.path) return false;

          const title = page.title || '';
          const description = page.description || '';

          return title.toLowerCase().includes(searchLower) ||
            description.toLowerCase().includes(searchLower);
        })
        .sort((a, b) => {
          // Если оба содержат поисковый запрос в заголовке, сортируем по популярности
          const aInTitle = (a.title || '').toLowerCase().includes(searchLower);
          const bInTitle = (b.title || '').toLowerCase().includes(searchLower);

          if (aInTitle && bInTitle) {
            return this.getPopularity(b.path) - this.getPopularity(a.path);
          }

          // Иначе, предпочитаем те, где поисковый запрос в заголовке
          if (aInTitle) return -1;
          if (bInTitle) return 1;

          // В остальных случаях сортируем по популярности
          return this.getPopularity(b.path) - this.getPopularity(a.path);
        });

      this.activeIndex = 0;
    },
    navigateTo(path) {
      if (!path) {
        console.error('Путь не определен');
        return;
      }

      // Записываем посещение
      this.recordVisit(path);

      // Проверяем, не совпадает ли новый путь с текущим
      if (this.$route.path === path) {
        this.closeSearch();
        return;
      }

      // Выполняем переход
      this.$router.push(path).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('Ошибка навигации:', err);
        }
      });

      this.closeSearch();
    },
    navigateToFirstResult() {
      if (this.filteredPages.length > 0) {
        const selectedPage = this.filteredPages[this.activeIndex];
        if (selectedPage && selectedPage.path) {
          this.navigateTo(selectedPage.path);
        }
      }
    }
  },
  mounted() {
    // Добавляем глобальную горячую клавишу для поиска (Ctrl+K)
    window.addEventListener('keydown', (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
        e.preventDefault();
        this.openSearch();
      }
    });

    // Слушаем изменения маршрута для записи посещений даже при прямой навигации
    this.$router.afterEach((to) => {
      this.recordVisit(to.path);
    });
  },
  beforeDestroy() {
    if (this.focusTimeout) {
      clearTimeout(this.focusTimeout);
    }

    // Удаляем обработчик горячих клавиш
    window.removeEventListener('keydown', (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
        e.preventDefault();
        this.openSearch();
      }
    });
  }
}
</script>

<style scoped>
.page-search {
  display: inline-block;
}

.search-btn {
  margin: 0 4px;
}

.search-card {
  max-height: 500px;
  overflow-y: auto;
}

.search-title {
  padding: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.search-list {
  padding: 0;
}

.search-item {
  cursor: pointer;
  transition: background-color 0.2s;
}

.search-item:hover,
.search-item-active {
  background-color: rgba(0, 0, 0, 0.04);
}

.search-actions {
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  padding: 8px;
}

/* Для темной темы */
.theme--dark .search-item:hover,
.theme--dark .search-item-active {
  background-color: rgba(255, 255, 255, 0.08);
}
</style>
